import { LIFETIME_PREMIUM_LINK } from "~/constants/socials";

export const DESKTOP_MIN_WIDTH = 910;

export const LIFETIME_PREMIUM_CTA_URL = `${LIFETIME_PREMIUM_LINK}?utm_source=website&utm_medium=popup&utm_campaign=lifetime-premium&utm_content=first_visit_popup`;
